import { useTranslation } from "react-i18next";
import { CBCreationOfProps } from "../../types";
import CBConsentsAccordion from "./CBConsentsAccordion";
import { Box, Stack, Tab, Tabs, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

interface CBConsentsTabsProps extends CBCreationOfProps {
    //isExpanded: boolean,
    index: number,
    consent: any,
    fullConsentList:any,
    //onRemove: (event: SyntheticEvent, index: number) => void
}

const CBConsentTab = ({
    creationOf,
    index,
    consent,
    fullConsentList
}: CBConsentsTabsProps) => {
    const { t } = useTranslation('customerbase');
    const theme = useTheme();
    const isCreationMode = !!creationOf;
    const [filteredChannel, setFilteredChannel] = useState<string[]>([])
    const [activeTabValue, setActiveTabValue] = useState(0);

    useEffect(() => {

        if (isCreationMode) return;
        if (!consent) return;
        let cc: string[] = []

        consent.consent.forEach((c: any) => {
            if (!cc.includes(c.communicationChannel)) {
                cc.push(c.communicationChannel)
            }
        })

        setFilteredChannel(cc);

    }, [consent, isCreationMode]);

    const handleChangeActiveTab = (e: React.SyntheticEvent, activeTab: number) => {
        e.stopPropagation();

        setActiveTabValue(activeTab);
    };

    const activeChannel = filteredChannel[activeTabValue];

    const consentsForActiveTab = consent.consent.filter(
        (c: any) => c.communicationChannel === activeChannel
    );

    return (
        <>
            <Tabs value={activeTabValue} onChange={handleChangeActiveTab} sx={{ mb: theme.spacing(2) }}>
                {filteredChannel.map((c, index) => (
                    <Tab key={c} label={c} value={index} />
                ))}
            </Tabs>
            <Stack rowGap={2}>
                {consentsForActiveTab.map((cons: any) => {
                    const originalIndex = fullConsentList.findIndex((c: any) => c === cons);

                    return (
                        <Box key={cons.id} role="tabpanel">
                            <CBConsentsAccordion creationOf={creationOf} index={originalIndex} consent={cons} />
                        </Box>
                    );
                })}
            </Stack>
        </>)
}

export default CBConsentTab;